import { useProfile } from '@ais-ui/profile';

export interface OwnableObject {
  owner?: string;
  username?: string;
  tplOwner?: string;
  createdBy?: string | null;
}

export const useOwnershipCheck = () => {
  const { username } = useProfile();

  const isOwner = (object: OwnableObject | undefined): boolean => {
    if (!object) {
      return true; // If no object, assume ownership (e.g., during creation)
    }
    
    // Check 'owner', 'username', 'tplOwner', and 'createdBy' fields for compatibility with different object types
    const objectOwner = object.owner || object.username || object.tplOwner || object.createdBy;
    
    if (!objectOwner) {
      return true; // If no owner field, assume ownership
    }
    
    return objectOwner === username;
  };

  return { isOwner, username };
};
